import {useEffect, useState} from "react";
import checkIcon from "../../assets/images/check-badge.svg";

const DeviceRemovalToast = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div
            className={`fixed bottom-0 left-0 right-0 flex justify-center transition-transform duration-500 ease-in-out ${
                isVisible ? "transform translate-y-0" : "transform translate-y-full"
            }`}
        >
            <div className="mb-4 flex items-center gap-2 rounded-lg bg-[#171725E5] px-4 py-3 text-white shadow-lg">
                <img src={checkIcon} loading="lazy" />
                <span className="font-medium">Device removed successfully</span>
            </div>
        </div>
    );
};

export default DeviceRemovalToast;